import styled from "styled-components";
import { useSelector } from "react-redux";
import props from "../../redux/props";
import { getUUID } from "../../utility";
import Container from "../UI/Container/Container";
import n1 from "../../assets/image/career/reasons/n1.svg";
import n2 from "../../assets/image/career/reasons/n2.svg";
import n3 from "../../assets/image/career/reasons/n3.svg";
import n4 from "../../assets/image/career/reasons/n4.svg";
import n5 from "../../assets/image/career/reasons/n5.svg";
import n6 from "../../assets/image/career/reasons/n6.svg";
import n7 from "../../assets/image/career/reasons/n7.svg";
import n8 from "../../assets/image/career/reasons/n8.svg";
import n9 from "../../assets/image/career/reasons/n9.svg";

const blue = "rgb(0, 79, 139)";
const numbers = [n1, n2, n3, n4, n5, n6, n7, n8, n9];

const StyledReasons = styled.div`
  font-family: "Open Sans", Helvetica, Arial, sans-serif;
`;

const Headline = styled.div`
  font-size: 60px;
  color: ${blue};
  text-align: center;
  font-weight: bold;
  @media (max-width: 992px) {
    font-size: 32px;
  }
`;

const Items = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  margin-top: 50px;
  gap: 25px;
  @media (max-width: 992px) {
    gap: 15px;
  }
`;

const Item = styled.div`
  display: flex;
  gap: 15px;
  flex-direction: column;
  align-items: center;
  width: 30%;
  @media (max-width: 992px) {
    width: calc(50% - 15px / 2);
  }
`;

const Number = styled.img`
  border-radius: 50px;
  height: 50px;
  width: 50px;
`;

const Title = styled.div`
  color: ${blue};
  font-size: 22px;
  font-weight: bold;
  text-align: center;
  @media (max-width: 992px) {
    font-size: 18px;
  }
`;

const Text = styled.div`
  text-align: center;
`;

const CareerReasons = () => {
  const t = useSelector((s) => s[props.TRANSLATION]);

  return (
    <StyledReasons>
      <Container>
        <Headline>{t.career.reasons.headline}</Headline>
        <Items>
          {t.career.reasons.items.map(
            (item: { title: string; text: string }, i: number) => (
              <Item key={getUUID()}>
                <Number src={numbers[i]} alt={`${i + 1}`} />
                <Title>{item.title}</Title>
                <Text>{item.text}</Text>
              </Item>
            )
          )}
        </Items>
      </Container>
    </StyledReasons>
  );
};

export default CareerReasons;
